import api from './api';

export default {
  login(credentials) {
    const { username, password } = credentials;
    return api.post('/auth/login', { username, password });
  }
};
